import { endsWith } from 'lodash'

export const formattedConfigurationLabel = ({ deviceSubtype, name }) => {
  const subtype = endsWith(deviceSubtype, '-pos') ? 'POS' : deviceSubtype
  return `${name} - (${subtype})`
}
